import React from "react";
import Modal from "react-bootstrap/Modal";
export default function FooterCustomModal({
  showModal,
  setShowModal,
  iframeUrl,
}) {
  return (
    <Modal
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      show={showModal}
      onHide={() => setShowModal(false)}
      className="alert-modal"
    >
      <Modal.Header closeButton>
        {/* <Modal.Title id="contained-modal-title-vcenter">
          <span
            dangerouslySetInnerHTML={{
              __html: title,
            }}
          ></span>
        </Modal.Title> */}
      </Modal.Header>

      <div closeButton>
        <Modal.Body className="modal-body invalidemailshowfp">
          {/* <span
          dangerouslySetInnerHTML={{
            __html: description,
          }}
        ></span> */}
          <iframe
            type="text/html"
            id="chat-player"
            title="chat-bot"
            width={"100%"}
            height={"450rem"}
            src={iframeUrl}
          ></iframe>
        </Modal.Body>
      </div>
      {/* <Modal.Footer className="justify-content-center"></Modal.Footer> */}
    </Modal>
  );
}
